import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from 'shared/actions/authentication';

import { openChat } from '../../actions/chat';
import { selectIsAuthenticated } from '../../selectors';
import { offerChatSelector } from '../../selectors/offerChat';

export const AuthorSendMessageContainer = () => {
  const offerChat = useSelector(offerChatSelector);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();

  const handleSendMessageClick = React.useCallback(() => {
    if (!isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => openChat(),
          alert: EAlertType.Chats,
        }),
      );

      return;
    }

    dispatch(openChat());
  }, [isAuthenticated, dispatch]);

  if (!offerChat || !offerChat.isChatsEnabled) {
    return null;
  }

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleSendMessageClick}>
      Написать сообщение
    </Button>
  );
};
